import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../../context/CookieConsentContext';
import './CookieSettingsModal.css';

const CookieSettingsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { consent, updateConsent } = useCookieConsent();

  // Local state for the toggle, initialized from the context
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);

  useEffect(() => {
    // Sync local state when the modal opens or the global consent changes
    setAnalyticsEnabled(consent === 'all');
  }, [isOpen, consent]);

  const handleSave = () => {
    const newDecision = analyticsEnabled ? 'all' : 'essential';
    updateConsent(newDecision);
    onClose();
  };

  const handleAcceptAll = () => {
    updateConsent('all');
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="cookie-settings-overlay" onClick={onClose}>
      <div className="cookie-settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cookie-modal-header">
          <h3>{t('cookieSettings.title')}</h3>
          <button onClick={onClose} className="cookie-modal-close-btn">
            &times;
          </button>
        </div>
        <div className="cookie-modal-body">
          <p>{t('cookieSettings.description')}</p>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <h4>{t('cookieSettings.necessary.title')}</h4>
              <span className="always-active">{t('cookieSettings.alwaysActive')}</span>
            </div>
            <p className="cookie-category-description">{t('cookieSettings.necessary.description')}</p>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <h4>{t('cookieSettings.analytics.title')}</h4>
              <label className="toggle-switch">
                <input type="checkbox" checked={analyticsEnabled} onChange={(e) => setAnalyticsEnabled(e.target.checked)} />
                <span className="slider"></span>
              </label>
            </div>
            <p className="cookie-category-description">{t('cookieSettings.analytics.description')}</p>
          </div>
        </div>
        <div className="cookie-modal-actions">
          <button onClick={handleSave}>{t('cookieSettings.save')}</button>
          <button onClick={handleAcceptAll} className="accept-all-btn">
            {t('cookieSettings.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieSettingsModal;
